import React, { useCallback } from 'react';
import { useQueryClient, useResponsive } from '@common-fe/common-fe';

import LettersOfMedicalNecessityPopup from '@/modules/MyDocuments/components/LettersOfMedicalNecessity/LettersOfMedicalNecessityPopup/LettersOfMedicalNecessityPopup';
import { LMNPopupMode } from '@/modules/MyDocuments/myDocuments.types';
import { GET_TRANSACTION_DETAILS_BY_CLAIM_ID } from '@/modules/transaction/hooks/useGetTransactionDetails.query';

interface Props {
  createForClaimId?: string;
  onSetVisible: (value: boolean) => void;
}

const TransactionDetailsLmnPopup: React.FC<Props> = ({ createForClaimId, onSetVisible }) => {
  const { isMobile } = useResponsive();
  const queryClient = useQueryClient();

  const handleSuccess = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: [GET_TRANSACTION_DETAILS_BY_CLAIM_ID, createForClaimId],
    });
  }, [queryClient, createForClaimId]);

  return (
    <LettersOfMedicalNecessityPopup
      mode={LMNPopupMode.UPLOAD}
      onSetVisible={onSetVisible}
      createForClaimId={createForClaimId}
      onSuccess={handleSuccess}
      isMobile={isMobile}
    />
  );
};

export default TransactionDetailsLmnPopup;
